import 'regenerator-runtime/runtime'
import axios from 'axios'
import { onWindowOpen } from './onWindowOpen'
const md5 = require('md5')

export const onSendxData = async ({ iu, pw }) => {
  const domin = '../../' //'http://192.168.0.14:3000/'
  // const domin = 'http://localhost:3000
  if (iu !== '') {
    if (pw !== '') {
      const xdata = `${md5(iu.toUpperCase())}o18901p${md5(pw)}`

      try {
        const response = await axios.post(`${domin}data-login.php`, {
          params: {
            xdata: xdata
          },
          crossdomain: true,
          headers: {
            'Access-Control-Allow-Origin': '*'
          }
        })
        if (response) {
          const { data } = response
          if (data[0]) {
            if (data[3] === '0') {
              onWindowOpen(data, '')
              return { err: false, tpw: null, tiu: null, tkdsp: false }
            } else {
              let objResponse = {
                err: true,
                tpw: 'No puedo enviar el MENSAJE',
                tiu: null,
                tkdsp: false,
                dip: false,
                code: data[3],
                data,
                epw: false, //Estatus Password
                eiu: false, //Estatus Usuario
                etk: false //Estatus Token
              }
              const sendCode = await SendMessageforCODE({ uid: data[3] })
              if (sendCode) {
                const { err, message } = sendCode
                objResponse = {
                  ...objResponse,
                  tpw: message,
                  tkdsp: true, // Indica que proceda con el toket admon
                  dip: !err,
                  err
                }
              }
              return objResponse
            }
          } else {
            return {
              err: false,
              tiu: data[1],
              tpw: null,
              tkdsp: false
            }
          }
        }
      } catch (err) {
        return {
          err: true,
          tiu: 'Hubo un error de comunicación!',
          tpw: null,
          tkdsp: false
        }
      }
    } else {
      return {
        err: false,
        tiu: null,
        tpw: 'Debes colocar tu Clave!',
        tkdsp: false
      }
    }
  } else {
    return {
      err: false,
      tiu: 'Debes colocar tu Usuario!',
      tpw: null,
      tkdsp: false
    }
  }
}

const SendMessageforCODE = async ({ uid }) => {
  //
  const Url = `https://token.saamqx.net:4700/send?id=${uid}`

  return await axios
    .get(Url)
    .then(({ data }) => {
      if (data) {
        return data
      }
      return null
    })
    .catch(() => {
      return null
    })
}
